import { Box } from "@mui/material";
import { FieldComponentProps, Typography } from "@platform/design-system";

import { formatDate } from "../../../../utils";

import { FORM_FIELDS } from "./constants";
import { getBooleanReview } from "./getReviewData";
import { ProductCoverageMap } from "./types";
import { getParentField } from "./utils";

type Props = FieldComponentProps<never> & {
  productMap: ProductCoverageMap;
};

const Row = ({
  label,
  value,
}: {
  label: string;
  value: string | number;
}): React.JSX.Element => (
  <Box component="tr">
    <Box component="td" sx={{ py: 1, pr: 10 }}>
      <Typography variant="body-medium">
        <strong>{label}</strong>
      </Typography>
    </Box>
    <Box component="td" sx={{ py: 1 }}>
      <Typography variant="body-medium">{value}</Typography>
    </Box>
  </Box>
);

const IncumbentData = ({
  field,
  methods,
  productMap,
}: Props): React.JSX.Element => {
  const { getValues } = methods;
  const prefix = getParentField(field.name, FORM_FIELDS.INCUMBENT_DATA);

  const incumbent = getValues(
    `${prefix}.${FORM_FIELDS.INCUMBENT_PRODUCT_ID}`,
  ) as number;

  const incumbentData = productMap.get(incumbent);

  if (!incumbentData) {
    return null;
  }

  return (
    <Box component="table" sx={{ ml: 1, borderCollapse: "collapse" }}>
      <Box component="tbody">
        <Row label="Policy Number" value={incumbentData.groupNumber} />
        <Row label="Carrier Name" value={incumbentData.carrier.name} />
        <Row label="Product Type" value={incumbentData.productType} />
        <Row label="Product Plan Type" value={incumbentData.productPlanType} />
        <Row
          label="Renewal Date"
          value={formatDate(incumbentData.renewalDate, true)}
        />
        <Row
          label="Contracted Carrier"
          value={getBooleanReview(incumbentData.carrier?.isContracted) ?? "No"}
        />
      </Box>
    </Box>
  );
};
export { IncumbentData };
